import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

// import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({});

class NecklaceSplash extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
    super(props);
    this.state = {

    };
	}

	componentDidMount() {
    document.title = 'Diamonds Direct';
    document.getElementsByTagName("META")[7].content="Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  splashNav(sku) {
    this.internalNav('jewelry/' + sku);
  }

	render() {
		return <div className='NecklaceSplash'>
      <div className='nsFloatingImg'>
        <img src='https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/necklace/layered.png' />
      </div>
      <div className='nsTitle'>Necklaces</div>
      <div className='nsTopSection'>
        <div className='nsTopBg'>
          <div className='nsTopBgImg1'>
            <img src='https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/necklace/layered.jpg' />
          </div>
          <div className='nsTopBgImg2'>
            <img src='https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/necklace/delicate.jpg' />
          </div>
        </div>
        <div className='nsTopBlockOuterWrapper'>
          <div className='nsTopBlock'>
            <div className={'nsTopBlockWrapper nsTopBlockWrapperLeft'}>
              <div className='nsTopBlockTitle'>LAYERED LOOKS</div>
              <div className='nsTopBlockCopy'>Make a statement with this sterling silver chain necklace showcasing a medley of blue topaz.</div>
              <div className='nsTopBlockButton' onClick={() => this.splashNav('TACSS00065')}>SHOP THIS NECKLACE</div>
            </div>
          </div>
        </div>
        <div className='nsMobileInterloper'>
          <img src='https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/necklace/delicate.jpg' />
        </div>
        <div className='nsTopBlockOuterWrapper'>
          <div className='nsTopBlock'>
            <div className={'nsTopBlockWrapper nsTopBlockWrapperRight'}>
              <div className='nsTopBlockTitle'>DELICATE PENDANTS</div>
              <div className='nsTopBlockCopy'>This stunning pendant features a beautiful pairing of diamonds and blue sapphires.</div>
              <div className='nsTopBlockButton' onClick={() => this.splashNav('NCOST04895')}>SHOP THIS NECKLACE</div>
            </div>
          </div>
          <div className='nsWeirdHangingOutImg'>
            <img src='https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/necklace/delicate.png' />
          </div>
        </div>
      </div>
      <div className='nsBottomSection'>
        <div className='nsbLeft' onClick={() => this.splashNav('NFANC08317')} style={{curson: 'pointer'}}>
          <div className='outerImg'>
            <img src='https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/necklace/floral.jpg' />
          </div>
          <div className='nsbLabel'>Floral Diamond Pendant</div>
        </div>
        <div className='nsbMid' style={{curson: 'pointer'}}>
          <div className='midImg' onClick={() => this.splashNav('NFANC16283')}>
            <img src='https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/necklace/leaf.jpg' />
          </div>
          <div className='nsbLabel'>Diamond Leaf Necklace</div>
          <div className='midImg' onClick={() => this.splashNav('NFANC15797')} style={{curson: 'pointer'}}>
            <img src='https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/necklace/cross.jpg' />
          </div>
          <div className='nsbLabel'>Diamond Cross Pendant</div>
        </div>
        <div className='nsbRight' onClick={() => this.splashNav('PRL8N00053')} style={{curson: 'pointer'}}>
          <div className='outerImg'>
            <img src='https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/necklace/pearl.jpg' />
          </div>
          <div className='nsbLabel'>Pearl Necklace</div>
        </div>
      </div>
		</div>;
	}
}
export default NecklaceSplash;

function mapStateToProps(state) {
  return {

  };
}

export const NecklaceSplashContainer = connect(
  mapStateToProps,
  allActionCreators
)(NecklaceSplash);


// WEBPACK FOOTER //
// ./src/components/views/gallery/blocks/splash/NecklaceSplash.jsx